export const book_demo = {
  label: "Fill out this form and we'll get back to you:",
  header: "Talk with sales",
  headerColor: "#8B80CD",
  fields: [
    { label: "Full name:", id: "full_name", type: "text", component: "input", required: true },
    { label: "Company:", id: "company", type: "text", component: "input", required: true },
    {
      label: "Business email address:",
      id: "email",
      type: "email",
      component: "input",
      required: true,
    },
    {
      label: "Please share high level use case or data source requirements",
      id: "message",
      component: "textarea",
      required: false,
    },
  ],
  form: {
    button_text: "Submit",
    consent: {
      beginning: "I agree to Demyst's ",
      link1_text: "Terms and Conditions",
      link1_url: "/terms-and-conditions",
      separator: " and ",
      link2_text: "Privacy Policy.",
      link2_url: "/privacy-policy",
    },
  },
  errors: {
    field_required: "This field is required!",
    incorrect_mail: "This email address is incorrect.",
  },
};

// export const contact = {
//   label: "Please fill out this form and we'll get back to you shortly:",
//   header: "Contact us",
//   headerColor: "#8B80CD",
//   fields: [
//     { label: "Full name", id: "full_name", type: "text", component: "input", required: true },
//     { label: "Business Email", id: "email", type: "email", component: "input", required: true },
//     { label: "Company", id: "company", type: "text", component: "input", required: true },
//     { label: "Role (optional)", id: "role", type: "text", component: "input", required: false },
//     { label: "How can Demyst help you?", id: "message", component: "textarea", required: false },
//   ],
//   form: {
//     button_text: "Submit",
//     consent: {
//       beginning: "I agree to Demyst's ",
//       link1_text: "Terms and Conditions",
//       link1_url: "/terms-and-conditions",
//       separator: " and ",
//       link2_text: "Privacy Policy.",
//       link2_url: "/privacy-policy",
//     },
//   },
//   errors: {
//     field_required: "This field is required!",
//     incorrect_mail: "This email address is incorrect.",
//   },
// };
